import {LeaderGuestFlag} from 'utils/guestForm';
import {useGetGuestId} from './useGetGuestId';
import {useGuest} from './useGuest';

function useIsOtherGuest() {
  const guestId = useGetGuestId();
  const {guest} = useGuest({id: guestId});

  return (guest?.is_leader ?? LeaderGuestFlag.get()) === false;
}

export {useIsOtherGuest};
